import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type ScrollAreaProps = {
  readonly id?: string;
  readonly children: ReactNode;
  readonly className?: string;
  readonly orientation?: "vertical" | "horizontal" | "both";
  readonly style?: React.CSSProperties;
};

export function ScrollArea({
  id,
  children,
  className = "",
  orientation = "both",
  ...props
}: ScrollAreaProps) {
  const overflowClass = {
    vertical: "overflow-y-auto overflow-x-hidden",
    horizontal: "overflow-x-auto overflow-y-hidden",
    both: "overflow-auto",
  }[orientation];

  return (
    <div
      id={id}
      className={twMerge("scroll-area", overflowClass, className)}
      {...props}
    >
      {children}
    </div>
  );
}
